
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/CustomerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BiFilter } from "react-icons/bi";
import { trackPromise } from 'react-promise-tracker';
// import * as BiIcon from "react-icons/bi"
import axios from 'axios';
import styled from "styled-components"



const PaymentSuccess = () => {


    const toaster = rsuite.useToaster();
    const [ItemList, setItemList] = useState([]);
    const [RecieptList, setRecieptList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("FactorHeaderId"));
    const [Tax, setTax] = useState(0);
    const [Code, setCode] = useState("");
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [TotalReciept, setTotalReciept] = useState(0);
    const [HeaderDiscount, setHeaderDiscount] = useState(0);
    const [HeaderTax, setHeaderTax] = useState(0);
    const [FreightPrice, setFreightPrice] = useState(0);
    const [ReadOnlyRegisterDate, setReadOnlyRegisterDate] = useState("");
    const [Customer, setCustomer] = useState("");
    const [FinancialBalance, setFinancialBalance] = useState("");
    const [Mobile, setMobile] = useState("");
    const [Address, setAddress] = useState("");
    const [TransferTyp, setTransferTyp] = useState(0);


    const Bind = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/FinalPayment/GetFactorByOnlineToken', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    "CustomerId": localStorage.getItem("CustomerFarmAsanId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    console.dir(result)
                    setReadOnlyRegisterDate(result[0].registerDate)
                    setHeaderPrice(result[0].totalPrice);
                    setTotalReciept(result[0].totalReciept);
                    setCode(result[0].code);
                    setCustomer(result[0].customer)
                    setMobile(result[0].mobile)
                    console.dir(result[0].address)

                    if (result[0].address != "" && result[0].address?.indexOf("|PostCode") > 1)
                        setAddress(result[0].city + " - " + result[0].address.split("|PostCode")[0] + " - کد پستی " + result[0].address.split("|PostCode")[1])
                    else
                        setAddress(result[0].city + " - " + result[0].address.split("|PostCode")[0])

                    setFreightPrice(result[0].freightPrice)
                    setHeaderTax(result[0].itemTax);
                    setTransferTyp(result[0].isSend);
                    setHeaderDiscount(result[0].discountPrice * 1 + result[0].itemDiscountPrice * 1);
                    var tmp = [];
                    if (result[0].children.length > 0) {

                        for (var i = 0; i < result[0].children.length; i++) {
                            tmp.push({
                                Price: PN.sliceNumber(result[0].children[i].price),
                                Tax: PN.sliceNumber(result[0].children[i].tax),
                                TotalPrice: PN.sliceNumber(result[0].children[i].totalPrice),
                                DiscountPrice: PN.sliceNumber(result[0].children[i].discountPrice),
                                TransferTypeComment: result[0].children[i].transferTypeComment,
                                TransferType: result[0].children[i].transferType,
                                Count: result[0].children[i].count,
                                Product: result[0].children[i].product,
                                Unit: result[0].children[i].unit,
                                PhotoUrl: result[0].children[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[0].children[i].photos[0].photoURLName : '',

                            })
                        }
                        console.dir(tmp)
                        setItemList(tmp)

                    }

                })
        )
    }


    useEffect(() => {
        Bind();
    }, []);



    return (
        <Layout title={'پیگیری سفارش ' + localStorage.getItem("UserFullNameFarmAsan")} >

            <rsuite.Row className="p-3">

                <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2 FarmAsan-bg p-3">
                    <rsuite.Row>
                        <rsuite.Card.Body >

                            <rsuite.Row className='p-1'>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="pt-2 Font13">
                                    <b> وضعیت فاکتور:   {TransferTyp == 0 ? <>ارسال نشده است </> :
                                        TransferTyp == 1 ? <> برخی آیتم ها ارسال شده است </> : <> تمام آیتم ها ارسال شده است </>} </b>
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className="pt-2">
                                    <b>شماره فاکتور:   </b>{Code}
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className="pt-2">
                                    <b> تاریخ:   </b> {ReadOnlyRegisterDate}

                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className="pt-2">
                                    <b>شماره همراه مشتری:   </b> {Mobile}
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className="pt-2">
                                    <b> نام و نام خانوادگی:   </b> {Customer}
                                </rsuite.Col>

                                <rsuite.Col className={Address != '' ? "pt-2" : "hide"} xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
                                    <b> آدرس:   </b>
                                    {Address}
                                </rsuite.Col>

                            </rsuite.Row>

                            <rsuite.Divider> مشخصات مالی پیش فاکتور</rsuite.Divider>
                            <rsuite.Row >
                                <rsuite.Col className={HeaderDiscount == 0 ? "hide" : "mt-2"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                    <b>تخفیف کل : </b> {PN.sliceNumber(HeaderDiscount)} ریال
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={Tax == 0 ? "hide" : "mt-2"} >
                                    <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                                </rsuite.Col>
                                <rsuite.Col className={localStorage.getItem("FreightPrice_ShowInFactorPrint") == "0" || FreightPrice == 0 ? "hide" : "mt-2"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}  >
                                    <b> کرایه : </b> {PN.sliceNumber(FreightPrice)} ریال
                                </rsuite.Col>
                                <rsuite.Col className={HeaderDiscount == 0 || localStorage.getItem("TotalPriceBeforDiscount_ShowInFactorPrint") == "0" ? "hide" : "mt-2"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                    <b>مبلغ قبل از تخفیف : </b> <text>  {PN.sliceNumber(HeaderPrice * 1 + HeaderDiscount * 1)} ریال </text>

                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className=' mt-2'>
                                    <b>مبلغ قابل پرداخت : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                                    <b>مبلغ پرداختی : </b> <text>  {PN.sliceNumber(TotalReciept)} ریال </text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                                    <b>مبلغ باقیمانده : </b> <text>  {PN.sliceNumber(HeaderPrice - TotalReciept)} ریال </text>
                                </rsuite.Col>
                            </rsuite.Row>
                        </rsuite.Card.Body>



                    </rsuite.Row>





                </rsuite.Col>
                <rsuite.Col xs={24} sm={24} md={24}>
                    <rsuite.Row className="justify-content-center align-items-center ">

                        {ItemList.map(item => (
                            <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2">

                                <rsuite.Panel bodyFill >
                                    <rsuite.Row>
                                        <rsuite.Col mdHidden xlHidden xxlHidden lgHidden xs={24} className='p-3 text-end'>
                                            <b> {item.Product} ( <span className={item.TransferType == 1 ? " FarmAsan-text-success fw-bold" : " FarmAsan-text-red fw-bold"}>{item.TransferTypeComment}</span>)</b>
                                        </rsuite.Col>
                                        <rsuite.Col xs={7} className="m-0 p-0">
                                            <rsuite.Image
                                                src={item.PhotoUrl}
                                                fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                                style={{ width: '250px', height: '170px' }}
                                                className="border-radius-half Cursor text-end"
                                            />
                                        </rsuite.Col>
                                        <rsuite.Col xs={17} className="m-0 p-1" >

                                            <rsuite.Card.Body >
                                                <rsuite.Row className='mt-2'>
                                                    <rsuite.Col md={24} xsHidden className=' text-end'>
                                                        <b> {item.Product} ( <span className={item.TransferType == 1 ? " FarmAsan-text-success fw-bold" : " FarmAsan-text-red fw-bold"}>{item.TransferTypeComment}</span>)</b>
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='p-2 text-end'>
                                                        <b> تعداد: </b> {item.Count} {item.Unit}
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='p-2 text-end'>
                                                        <b>  قیمت واحد : </b> {item.Price} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='p-2 text-end'>
                                                        <b>  مالیات  : </b> {item.Tax} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='p-2 text-end'>
                                                        <b>  تخفیف  : </b> {item.DiscountPrice} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='p-2 text-end'>
                                                        <b>  قیمت کل : </b> {item.TotalPrice} ریال
                                                    </rsuite.Col>
                                                    {/* <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={item.SaleType == 2 ? 'p-2 text-end' : "hide"}> */}
                                                    {/* <span className="text-success text-decoration-underline fw-bold">رزرو شده است</span> */}

                                                    {/* </rsuite.Col> */}




                                                </rsuite.Row>
                                            </rsuite.Card.Body>

                                        </rsuite.Col>
                                    </rsuite.Row>

                                </rsuite.Panel>
                            </rsuite.Col>

                        ))}

                    </rsuite.Row>

                </rsuite.Col>

            </rsuite.Row>
        </Layout >
    )
};

export default PaymentSuccess;